import { useRouter } from 'next/router'

export const useCurrentPath = () => {
  const router = useRouter()
  const path = router.asPath
  return {
    path: path ?? '/',
  }
}
